// @ts-nocheck
import { API_URL } from '$lib/conf'
import user from './user'
import { writable } from 'svelte/store'

function buildCustomStore() {
    let initial = window.localStorage.getItem('ProviderData')
    initial = initial ? JSON.parse(initial) : null
    const { subscribe, update, set } = writable(initial)
    const _update = (data) => {
        return update((p) => {
            let tmp = { ...p, ...data }
            window.localStorage.setItem('ProviderData', JSON.stringify(tmp))
            return tmp
        })
    }
    const load = async (_) => {
        return user.subscribe(val => {
            return val
                ? user.fetch(`${API_URL}/provider/${user.currentAccount}`)
                      .then(async (r) => {
                          if (r.ok) {
                              let ret = await r.json()
                              set(ret)
                              window.localStorage.setItem(
                                  'ProviderData',
                                  JSON.stringify(ret)
                              )
                              return ret
                          } else {
                              throw new Error(
                                  'No se puede obtener el proveedor'
                              )
                          }
                      })
                      .catch((_) => null)
                : null
        })
    }
    return {
        subscribe,
        load,
        reload: load,
        update: _update,
    }
}
const provider = buildCustomStore()
export default provider
